import React from 'react';

const WarnIcon = () => (
  <svg
    width="16px"
    height="16px"
    viewBox="0 0 16 16"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g
      id="warning-icon-group-1"
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g
        id="Settings---Deactivated-User-Alert-Copy-2"
        transform="translate(-767.000000, -469.000000)"
        fill="#B34A00"
      >
        <g
          id="warning-icon-group-2"
          transform="translate(759.000000, 430.000000)"
        >
          <path
            d="M16,39 C20.418278,39 24,42.581722 24,47 C24,51.418278 20.418278,55 16,55 C11.581722,55 8,51.418278 8,47 C8,42.581722 11.581722,39 16,39 Z M16.4166667,50 L15.5833333,50 C15.4452621,50 15.3333333,50.1119288 15.3333333,50.25 L15.3333333,50.25 L15.3333333,51.0833333 C15.3333333,51.2214045 15.4452621,51.3333333 15.5833333,51.3333333 L15.5833333,51.3333333 L16.4166667,51.3333333 C16.5547379,51.3333333 16.6666667,51.2214045 16.6666667,51.0833333 L16.6666667,51.0833333 L16.6666667,50.25 C16.6666667,50.1119288 16.5547379,50 16.4166667,50 L16.4166667,50 Z M16.4166667,42.6666667 L15.5833333,42.6666667 C15.4452621,42.6666667 15.3333333,42.7785955 15.3333333,42.9166667 L15.3333333,42.9166667 L15.3333333,48.4166667 C15.3333333,48.5547379 15.4452621,48.6666667 15.5833333,48.6666667 L15.5833333,48.6666667 L16.4166667,48.6666667 C16.5547379,48.6666667 16.6666667,48.5547379 16.6666667,48.4166667 L16.6666667,48.4166667 L16.6666667,42.9166667 C16.6666667,42.7785955 16.5547379,42.6666667 16.4166667,42.6666667 L16.4166667,42.6666667 Z"
            id="alert-icon---warning"
          ></path>
        </g>
      </g>
    </g>
  </svg>
);

export default WarnIcon;
